import PropTypes from 'prop-types';
import React from 'react';

function CourseCTA({
  Amount, batchName, productStatus, batchPrice, handleClick, cusPadding, showBatchPopup, handleRequestCall,
}) {
  // console.log('batchPrice', batchPrice);
  return (
    <div>
      <div className={`flex items-center ${cusPadding || 'py-3'} lg:justify-center justify-between  ${Amount !== '' ? 'lg:justify-between' : 'lg:justify-end'}`}>
        {Amount !== '' && (
        <div className="flex flex-col">
          <span className="flex flex-col items-start justify-center mr-4 flex-nowrap min-w-36">
            <span className="text-xs font-semibold lg:text-base text-left">
              {/* GS-B01 (for CSE 2026) */}
              {batchName}
            </span>
            <span className="text-sm font-medium lg:text-lg">{Amount}</span>
          </span>
          {batchPrice?.[0]?.instalmentPlans?.length > 0 && <small className="font-normal lg:text-xs text-[10px]">Installment Options Available</small> }
        </div>
        )}

        <div className="lg:w-full w-[48%] max-w-[218px] relative group overflow-hidden shadow-[0px_4px_4px_0px_#DBF2FF]">
          {(() => {
            const disabled = !batchName && showBatchPopup;
            const baseClass = `${disabled ? 'bg-[#ccc]' : 'bg-[#045692]'} text-white w-full rounded-md lg:px-6 px-2 py-2 lg:text-base text-sm lg:font-semibold`;

            // eslint-disable-next-line no-nested-ternary
            const label = productStatus?.length > 1
              ? 'Continue'
              : batchPrice?.[0]?.isPurchaseAllowed
                ? 'Start Your Prep'
                : 'Get Expert Support';

            return (
              <button
                type="button"
                disabled={disabled}
                onClick={label === 'Get Expert Support' ? handleRequestCall : handleClick}
                className={baseClass}
              >
                {label}
              </button>
            );
          })()}
          <div className="absolute bg-[linear-gradient(180deg,rgb(85_155_228_/0%)_0%,rgb(162_199_239_/20%)_50%,rgba(22,98,177,0)_100%)] inset-0 opacity-0 group-hover:opacity-100 animate-rain pointer-events-none" />

        </div>

        {/* <div className="lg:w-full w-[48%] max-w-[218px] relative group overflow-hidden shadow-[0px_4px_4px_0px_#DBF2FF]">
          {productStatus?.length > 1
            ? <button type="button" disabled={!batchName && showBatchPopup} className={`${!batchName && showBatchPopup ? 'bg-[#ccc]' : 'bg-[#045692]'} text-white w-full rounded-md lg:px-6 px-2 py-2 lg:text-base text-sm  lg:font-semibold`} onClick={handleClick}>Continue</button>
            : batchPrice?.[0]?.isPurchaseAllowed ? (
              <button type="button" disabled={!batchName && showBatchPopup} className={`${!batchName && showBatchPopup ? 'bg-[#ccc]' : 'bg-[#045692]'} text-white  w-full rounded-md lg:px-6 px-2 py-2 lg:text-base text-sm lg:font-semibold`} onClick={handleClick}>Start Your Prep</button>
            ) : (
              <button type="button" disabled={!batchName && showBatchPopup} onClick={handleClick} className={`${!batchName && showBatchPopup ? 'bg-[#ccc]' : 'bg-[#045692]'} rounded-md text-white w-full lg:text-base text-sm lg:px-6 px-2 py-3  lg:font-semibold`}>Get Expert Support</button>

            )}
          <div className="absolute bg-[linear-gradient(180deg,rgb(85_155_228_/0%)_0%,rgb(162_199_239_/20%)_50%,rgba(22,98,177,0)_100%)] inset-0 opacity-0 group-hover:opacity-100 animate-rain pointer-events-none" />

        </div> */}
      </div>
    </div>
  );
}

CourseCTA.propTypes = {
  batchName: PropTypes.any,
  Amount: PropTypes.any,
  productStatus: PropTypes.any,
  batchPrice: PropTypes.any,
  handleClick: PropTypes.any,
  cusPadding: PropTypes.any,
  showBatchPopup: PropTypes.any,
  handleRequestCall: PropTypes.any,
};

export default CourseCTA;
